// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__whwR9","spin":"Spinner_spin__+0R4j"};